// extracted by mini-css-extract-plugin
export default {"section":"ContactUsPage_section__1Ovb9","heading":"ContactUsPage_heading__VMjCG"};